import { render, staticRenderFns } from "./ServiceGroups.vue?vue&type=template&id=21c8336e&scoped=true&"
import script from "./ServiceGroups.vue?vue&type=script&lang=js&"
export * from "./ServiceGroups.vue?vue&type=script&lang=js&"
import style0 from "./ServiceGroups.vue?vue&type=style&index=0&id=21c8336e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c8336e",
  null
  
)

export default component.exports